import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';

import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { RegisterBusinessComponent } from './register-business/register-business.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BusinessLoginComponent } from './business-login/business-login.component';
import { ServiceOfferDialogComponent } from './service-offer-dialog/service-offer-dialog.component';
import { BookingDetailComponent } from './booking-detail/booking-detail.component';
import { CustomerDetailsDialogComponent } from './customer-details-dialog/customer-details-dialog.component';
import { BookingSuccessDialogComponent } from './booking-success-dialog/booking-success-dialog.component';
import { CategoryDetailComponent } from './category-detail/category-detail.component';
import { BookingOrdersComponent } from './booking-orders/booking-orders.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthDialogComponent } from './auth-dialog/auth-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UploadLpoDialogComponent } from './booking-orders/upload-lpo-dialog/upload-lpo-dialog.component';
import { ReviewDialogComponent } from './review-dialog/review-dialog.component';
import { ConfirmEnquiryComponent } from './booking-detail/confirm-enquiry/confirm-enquiry.component';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BookingGarageComponent } from './booking-garage/booking-garage.component';
import { OtherServicesComponent } from './other-services/other-services.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { PlanSuccessDialogComponent } from './register-business/plan-success-dialog/plan-success-dialog.component';
import { CartComponent } from './cart/cart.component';
import { ConfirmPaymentDialogComponent } from './booking-detail/confirm-enquiry/confirm-payment-dialog/confirm-payment-dialog.component';
import { ProfileComponent } from './profile/profile.component';
import { LpoTemplateDialogComponent } from './profile/lpo-template-dialog/lpo-template-dialog.component';
import { TimeSheetTemplateDialogComponent } from './profile/time-sheet-template-dialog/time-sheet-template-dialog.component';
import { TimesheetEntryDialogComponent } from './booking-orders/timesheet-entry-dialog/timesheet-entry-dialog.component';
import { ComponentsModule } from '../../components/components.module';
import { NotRegisteredDialogComponent } from './login/not-registered-dialog/not-registered-dialog.component';
import { RoleSelectionDialogComponent } from './role-selection-dialog/role-selection-dialog.component';
import { BusinessDetailDialogComponent } from './business-detail-dialog/business-detail-dialog.component';
import { OrderDetailsComponent } from './booking-orders/order-details/order-details.component';
import { RoleSetupPageComponent } from './role-setup/role-setup.component';
import { ImageCarouselDialogComponent } from './profile/image-carousel-dialog/image-carousel-dialog.component';
import { UserNotificationsComponent } from './notifications/notifications.component';
import { ForgotPasswordDialogComponent } from './forgot-password-dialog/forgot-password-dialog.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MatTableModule } from '@angular/material/table';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { RentalResponsibilityComponent } from './rental-responsibility/rental-responsibility.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AiButtonComponent } from '../../ai/ai-button/ai-button.component';
import { AiDrawerComponent } from '../../ai/ai-drawer/ai-drawer.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    LandingpageComponent,
    RegisterBusinessComponent,
    CustomerDetailsDialogComponent,
    BusinessLoginComponent,
    ServiceOfferDialogComponent,
    BookingDetailComponent,
    BookingSuccessDialogComponent,
    CategoryDetailComponent,
    BookingOrdersComponent,
    AuthDialogComponent,
    UploadLpoDialogComponent,
    ReviewDialogComponent,
    ConfirmEnquiryComponent,
    SearchFilterComponent,
    BookingGarageComponent,
    OtherServicesComponent,
    AboutUsComponent,
    PlanSuccessDialogComponent,
    CartComponent,
    ConfirmPaymentDialogComponent,
    ProfileComponent,
    LpoTemplateDialogComponent,
    TimeSheetTemplateDialogComponent,
    TimesheetEntryDialogComponent,
    NotRegisteredDialogComponent,
    RoleSelectionDialogComponent,
    BusinessDetailDialogComponent,
    OrderDetailsComponent,
    RoleSetupPageComponent,
    ImageCarouselDialogComponent,
    UserNotificationsComponent,
    ForgotPasswordDialogComponent,
    ResetPasswordComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    CompanyDetailsComponent,
    HelpCenterComponent,
    RentalResponsibilityComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatDividerModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatSelectModule,
    MatSidenavModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    MatRadioModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatCheckboxModule,
    SharedModule,
    ComponentsModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTableModule,
    MatTooltipModule,
    AiButtonComponent,
    AiDrawerComponent,
  ],
  exports: [
    LoginComponent,
    RegisterComponent,
    TimesheetEntryDialogComponent,
    ProfileComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    CompanyDetailsComponent,
    HelpCenterComponent,
    RentalResponsibilityComponent,
  ],
})
export class AuthModule { }